import { useIsCartInFlightRequests } from '@/features/pos/components/Cart/hooks/cart-optimistic-update-counter'
import DecreaseQuantityButton from '@/features/pos/components/buttons/DecreaseQuantityButton'
import DeleteButton from '@/features/pos/components/buttons/DeleteButton'
import IncreaseQuantityButton from '@/features/pos/components/buttons/IncreaseQuantityButton'
import { FC, memo } from 'react'
import { StyleSheet, View } from 'react-native'

interface ActionButtonsProps {
    id: string
    decreaseDisabled: boolean
    onDelete: (id: string) => void
    onChangeQuantity: (id: string, changeQuantity: number) => void
}

const ActionButtons: FC<ActionButtonsProps> = ({
    id,
    decreaseDisabled,
    onDelete,
    onChangeQuantity,
}) => {
    const isCartInFlightRequests = useIsCartInFlightRequests()

    return (
        <View style={styles.container}>
            <DeleteButton disabled={isCartInFlightRequests} onPress={() => onDelete(id)} />
            <View style={styles.quantityActions}>
                <DecreaseQuantityButton
                    disabled={decreaseDisabled}
                    onPress={() => onChangeQuantity(id, -1)}
                />
                <IncreaseQuantityButton onPress={() => onChangeQuantity(id, 1)} />
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 8,
        flexWrap: 'wrap',
    },
    quantityActions: {
        flexDirection: 'row',
        gap: 8,
    },
})

export default memo(ActionButtons)
